export default __webpack_public_path__ + "static/media/dream-landscape.d0408122.jpg";